import App from './classes/App.js';

document.addEventListener('DOMContentLoaded', () => {
    const myApp = new App();
    
    // Roep de async init aan en vang eventuele fouten op
    myApp.init().catch(err => {
        console.error("Fout bij het laden van de app:", err);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.hamburger');
    const navMenu = document.querySelector('.nav-menu');

    if (hamburger && navMenu) {
        // Open of sluit het menu bij een klik op de SVG
        hamburger.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });

        // Sluit het menu zodra er op een link wordt geklikt
        const navLinks = document.querySelectorAll('.nav-menu a');
        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                navMenu.classList.remove('active');
            });
        });
    }
});